import { render, staticRenderFns } from "./my.vue?vue&type=template&id=23476b4d&scoped=true"
import script from "./my.vue?vue&type=script&lang=js"
export * from "./my.vue?vue&type=script&lang=js"
import style0 from "./my.vue?vue&type=style&index=0&id=23476b4d&prod&lang=less&scoped=true"
import style1 from "./my.vue?vue&type=style&index=1&id=23476b4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23476b4d",
  null
  
)

export default component.exports